import { useQueryUserEHRLaunchProfiles } from '@/hooks/query/integrations/useQueryUserEHRLaunchProfiles';
import { type UserEHRLaunchProfile } from '@/types';

export const useCurrentEhrLaunchProfile = (): UserEHRLaunchProfile | undefined => {
  const { data: userEhrLaunchProfiles } = useQueryUserEHRLaunchProfiles();

  if ((userEhrLaunchProfiles ?? []).length === 0) {
    return undefined;
  }

  return userEhrLaunchProfiles?.at(0);
};
